import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import Newsletter from "gatsby-theme-blank/src/components/Newsletter/newsletter"
import PropTypes from "prop-types"
import Ariane from "../../components/Ariane/ariane"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeSimplenewsIssue(path: { alias: { eq: $slug } }) {
      ...NewsletterIssue
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const NewsletterTemplate = ({ data }) => {
  const newsletter = data.nodeSimplenewsIssue
  return (
    <Layout isDetail={true}>
      <SEO title={newsletter.title} />
      <Ariane isListing={true} pageName={newsletter.title} />
      <Newsletter newsletter={newsletter} />
    </Layout>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

NewsletterTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default NewsletterTemplate
